import React, { Component } from 'react';
import PropTypes from 'prop-types';
import mergeClassNames from 'merge-class-names';
import ReactTooltip from 'react-tooltip';
import 'moment-timezone';
import moment from 'moment';

import { tileProps } from './shared/propTypes';
import Moment from 'react-moment';

export default class Tile extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      date,
      tileClassName,
      tileContent,
      view,
    } = nextProps;

    const nextState = {};

    if (tileClassName !== prevState.tileClassNameProps) {
      nextState.tileClassName = typeof tileClassName === 'function' ? tileClassName({ date, view }) : tileClassName;
      nextState.tileClassNameProps = tileClassName;
    }

    if (tileContent !== prevState.tileContentProps) {
      nextState.tileContent = typeof tileContent === 'function' ? tileContent({ date, view }) : tileContent;
      nextState.tileContentProps = tileContent;
    }

    return nextState;
  }

  state = {};

  render() {
    const {
      activeStartDate,
      children,
      classes,
      date,
      formatAbbr,
      locale,
      maxDate,
      maxDateTransform,
      minDate,
      minDateTransform,
      onClick,
      onMouseOver,
      style,
      tileDisabled,
      view,
      events,
    } = this.props;
    const { tileClassName, tileContent } = this.state;

    return (
      <button
        data-tip
        data-for={`events-${date}`}
        className={mergeClassNames(classes, tileClassName)}
        disabled={
          (minDate && minDateTransform(minDate) > date)
          || (maxDate && maxDateTransform(maxDate) < date)
          || (tileDisabled && tileDisabled({ activeStartDate, date, view }))
        }
        onFocus={onMouseOver && (() => onMouseOver(date))}
        onMouseOver={onMouseOver && (() => onMouseOver(date))}
        onClick={() => {
          if (events.length === 0) return;
          if (onClick) onClick(events[0].event_id);
        }}
        style={style}
        type="button"
      >
        {formatAbbr
          ? (
            <abbr aria-label={formatAbbr(locale, date)}>
              {children}
            </abbr>
          )
          : children}
        {tileContent}
        <span className="d-block event-dot">
          {events.length > 0 ? (<span className="dot">&nbsp;</span>) : ''}
        </span>
        {events.length > 0 && (
          <ReactTooltip
            className={mergeClassNames(classes, tileClassName)}
            id={`events-${date}`}
            type="dark"
            effect="solid"
            place="top"
            multiline
          >
            {events.map((e) => {
              const start = moment.utc(e.start_time);
              const end = moment.utc(e.end_time);
              const userTimezone = moment.tz.guess();
              return (
                <div key={e.event_id}>
                  {e.summary} &nbsp;
                  {!e.is_all_day && (
                    <span>
                      <Moment format="h:mm A" tz={userTimezone}>{start}</Moment>&nbsp;-&nbsp;
                      <Moment format="h:mm A" tz={userTimezone}>{end}</Moment>&nbsp;
                      <Moment format="z" tz={userTimezone}>{start}</Moment>
                    </span>)}
                </div>
              );
            })}
          </ReactTooltip>
        )}
      </button>
    );
  }
}

Tile.propTypes = {
  ...tileProps,
  children: PropTypes.node.isRequired,
  formatAbbr: PropTypes.func,
  maxDateTransform: PropTypes.func.isRequired,
  minDateTransform: PropTypes.func.isRequired,
};
